export var RecordingSource;
(function (RecordingSource) {
    RecordingSource["malka"] = "malka";
    RecordingSource["cs"] = "cs-sr";
})(RecordingSource || (RecordingSource = {}));
//# sourceMappingURL=recording-source.js.map